import store from '../store';
import questions from './questionsMan';
import analyticsNames from './analyticsNamesMan';

let transitionTimeout = null;
let transitionBetweenStepsTime;
let preventActionFromFiring = false;
let preventActionTimer;
let dataSended = false;

function getTransitionBetweenStepsTime () {
	return parseInt(
		getComputedStyle(document.documentElement).getPropertyValue('--transitionBetweenStepsTime').slice(0, -2),
		10
	);
}

const steps = {
	quizStarted: false,
	setup: ({ stepsConfig, currentStep, stepsDetails }) => {
		transitionBetweenStepsTime = getTransitionBetweenStepsTime();

		const stepsList = [];

		stepsConfig.forEach(step => {
			stepsList.push(
				steps.createStep({
					name: step.name,
					showActionBar: stepsDetails[step.name] && stepsDetails[step.name].showActionBar
				})
			);
		});

		store.dispatch({
			type: 'SET_STEPS',
			payload: stepsList
		});

		store.dispatch({
			type: 'SET_TOTAL_STEPS',
			payload: stepsList.length
		});

		currentStep && steps.navigate.to(currentStep);
		steps.setCurrentStepIndex();
	},
	createStep: ({ name, showActionBar }) => ({
		name,
		showActionBar
	}),
	setPreviousAndNextStepsStatus: () => {
		const stepsList = store.getState().steps.list;
		const { currentStepIndex } = store.getState().steps;

		if (stepsList[currentStepIndex - 1]) {
			store.dispatch({
				type: 'SET_PREVIOUS_STEP',
				payload: stepsList[currentStepIndex - 1].name
			});
		} else {
			store.dispatch({
				type: 'SET_PREVIOUS_STEP',
				payload: null
			});
		}

		if (stepsList[currentStepIndex + 1]) {
			store.dispatch({
				type: 'SET_NEXT_STEP',
				payload: stepsList[currentStepIndex + 1].name
			});
		} else {
			store.dispatch({
				type: 'SET_NEXT_STEP',
				payload: null
			});
		}
	},
	setCurrentStepIndex: () => {
		const stepsList = store.getState().steps.list;
		const { currentStep } = store.getState().steps;
		let currentStepIndex = null;

		stepsList.forEach((step, index) => {
			if (currentStep === step.name) {
				currentStepIndex = index;
			}
		});

		store.dispatch({
			type: 'SET_CURRENT_INDEX',
			payload: currentStepIndex
		});
	},
	navigate: {
		to: stepName => {
			clearTimeout(transitionTimeout);
			document.body.classList.add('onTransition');

			transitionTimeout = setTimeout(() => {
				document.body.classList.remove('onTransition');
			}, transitionBetweenStepsTime + 30);

			store.dispatch({
				type: 'STEP_GO_TO',
				payload: stepName
			});

			if (store.getState().steps.list) {
				steps.setCurrentStepIndex();
				steps.setPreviousAndNextStepsStatus();
				steps.checkActionBarShowing();
			}

			document.querySelector('#root').scrollTo(0, 0);
		},
		forward: ({ preventAction }) => {
			if (preventActionFromFiring) return;
			clearTimeout(preventActionTimer);

			if (preventAction) {
				preventActionFromFiring = true;

				preventActionTimer = setTimeout(() => {
					preventActionFromFiring = false;
				}, preventAction);
			}

			const stepsList = store.getState().steps.list;
			const { currentStep } = store.getState().steps;
			let stepAfterCurrent = null;

			stepsList.forEach((step, index) => {
				if (step.name === currentStep && stepsList[index + 1]) {
					stepAfterCurrent = stepsList[index + 1].name;
				}
			});

			steps.analytics.stepsUpdated({ step: currentStep });

			if (!stepAfterCurrent) {
				store.dispatch({
					type: 'TOGGLE_LOADER',
					payload: true
				});

				console.warn('Can\'t navigate forward because you at the end of stepsList');
				return;
			}

			steps.navigate.to(stepAfterCurrent);
		},
		back: () => {
			const stepsList = store.getState().steps.list;
			const { currentStep } = store.getState().steps;
			let stepBeforeCurrent = null;

			stepsList.forEach((question, index) => {
				if (question.name === currentStep && stepsList[index - 1]) {
					stepBeforeCurrent = stepsList[index - 1].name;
				}
			});

			if (!stepBeforeCurrent) {
				console.warn('Can\'t navigate back because you at the start of stepsList');
				return;
			}

			steps.navigate.to(stepBeforeCurrent);
		}
	},
	setStepStatus: ({ stepName, stepStatus }) => {
		const stepsList = store.getState().steps.list;

		stepsList.forEach(step => {
			if (step.name === stepName) {
				step.isCompleted = stepStatus;
			}
		});

		store.dispatch({
			type: 'SET_STEP_STATUS',
			payload: stepsList
		});

		steps.setCurrentStepCompletedStatus();
	},
	getStepStatus: ({ stepName }) => {
		const stepsList = store.getState().steps.list;
		let isStepCompled = false;

		stepsList.forEach(step => {
			if (step.name === stepName) {
				isStepCompled = step.isCompleted;
			}
		});

		return isStepCompled;
	},
	setCurrentStepCompletedStatus: () => {
		const stepsList = store.getState().steps.list;
		const { currentStepIndex } = store.getState().steps;

		store.dispatch({
			type: 'SET_CURRENT_STEP_COMPLETED_STATUS',
			payload: stepsList[currentStepIndex].isCompleted
		});
	},
	checkActionBarShowing: () => {
		const stepsList = store.getState().steps.list;
		const { currentStepIndex } = store.getState().steps;
		const actionBarShowed = stepsList[currentStepIndex].showActionBar;

		if (actionBarShowed) {
			document.body.classList.add('showActionBar');
		} else {
			document.body.classList.remove('showActionBar');
		}

		store.dispatch({
			type: 'CHECK_ACTION_BAR_SHOWING',
			payload: actionBarShowed
		});
	},
	userMovedToNextStepByClick: ({ byNextStep }) => {
		const { nextStep } = store.getState().steps;
		const { currentStep } = store.getState().steps;
		const step = byNextStep ? nextStep : currentStep;

		if (step === 'workouts_preferences' && document.querySelector('#workoutsPreferenciesVideo')) {
			document.querySelector('#workoutsPreferenciesVideo').play();
		}

		if (step === 'weight' && document.querySelector('#weight')) {
			document.querySelector('#weight').focus();
			setTimeout(window.scrollTo(0, -285), 100);
		}

		if (step === 'target_weight' && document.querySelector('#target_weight')) {
			document.querySelector('#target_weight').focus();
			setTimeout(window.scrollTo(0, -285), 100);
		}

		if (step === 'height' && (window.userHeightNode || document.querySelector('#heightF'))) {
			window.userHeightNode ? window.userHeightNode.focus() : document.querySelector('#heightF').focus();
			setTimeout(window.scrollTo(0, -285), 100);
		}

		if (step === 'mail' && document.querySelector('#mail')) {
			document.querySelector('#mail').focus();

			setTimeout(window.scrollTo(0, -285), 100);
			// setTimeout(() => {
			//   window.scrollTo(0, document.querySelector('#mail').getBoundingClientRect().top);
			// }, 100);
		}
	},
	userMovedToPreviousStepByClick: () => {
		const { currentStep } = store.getState().steps;

		if (currentStep === 'workouts_preferences' && document.querySelector('#workoutsPreferenciesVideo')) {
			document.querySelector('#workoutsPreferenciesVideo').play();
		}

		if (currentStep === 'weight' && document.querySelector('#weight')) {
			document.querySelector('#weight').focus();
			setTimeout(window.scrollTo(0, -285), 100);
		}

		if (currentStep === 'target_weight' && document.querySelector('#target_weight')) {
			document.querySelector('#target_weight').focus();
			setTimeout(window.scrollTo(0, -285), 100);
		}

		if (currentStep === 'height' && (window.userHeightNode || document.querySelector('#heightF'))) {
			window.userHeightNode ? window.userHeightNode.focus() : document.querySelector('#heightF').focus();
			setTimeout(window.scrollTo(0, -285), 100);
		}

		if (currentStep === 'mail' && document.querySelector('#mail')) {
			document.querySelector('#mail').focus();
			setTimeout(window.scrollTo(0, -285), 100);
		}
	},
	analytics: {
		stepsUpdated ({ step }) {
			const answer = questions.getAnswers({ questionName: step });
			const { currentStepIndex } = store.getState().steps;
			const { totalSteps } = store.getState().steps;
			const isItLastStep = currentStepIndex === totalSteps - 1;
			const { savedAnswers } = store.getState().questions;
			const { promocode } = store.getState().global;
			const dataToSend = {};

			if (isItLastStep) {
				steps.analytics.send({
					event: {
						event: 'funnel on onboarding',
						quiz_action: 'quiz end'
					}
				});

				// Remove all empty answers and add data to dataToSend object
				Object.entries(savedAnswers).forEach(el => {
					if (Object.keys(el[1]).length !== 0) {
						dataToSend[`${el[0]}`] = {};

						// eslint-disable-next-line prefer-destructuring
						dataToSend[el[0]].answers = el[1];
					}
				});

				if (Object.prototype.hasOwnProperty.call(dataToSend, 'mail') && !dataToSend.mail.answers.agreeToInbox) {
					delete dataToSend.mail;
				}

				if (dataSended) return;
				dataSended = true;

				fetch(`${process.env.REACT_APP_API_URL}/v4/web_extra_data`, {
					method: 'POST',
					body: JSON.stringify({
						bundle_id: 'com.verv.app',
						promocode: encodeURIComponent(promocode),
						extra_data: {
							user_data: dataToSend
						}
					})
				});
			}

			if (!steps.quizStarted) {
				steps.quizStarted = true;

				steps.analytics.send({
					event: {
						event: 'funnel on onboarding',
						quiz_action: 'quiz start'
					}
				});
			}

			if (answer && answer.value && answer.units) {
				steps.analytics.send({
					event: {
						event: 'onboarding_question',
						quiz_question: analyticsNames[step],
						quiz_answer: answer.value.value,
						quiz_answer_units: answer.units.value
					}
				});

				return;
			}

			let answers;

			if (step === 'mail') {
				const mail = questions.getAnswers({ questionName: 'mail' });
				const agreeToInbox = mail.agreeToInbox || false;

				steps.analytics.send({
					event: {
						event: 'onboarding_question',
						quiz_question: 'User has agreed to inbox',
						quiz_answer: agreeToInbox
					}
				});

				steps.analytics.send({
					event: {
						email: mail.value
					}
				});

				if (window.web_platform === 'facebook_web' && window.fbq) {
					window.fbq('track', 'contact');
				}

				steps.analytics.send({
					event: {
						event: 'funnel on onboarding',
						quiz_action: 'email send',
						payment_type: mail.value
					}
				});

				return;
			}

			if (answer && Object.keys(answer).length > 1) {
				answers = [];

				Object.keys(answer).forEach(currentnswer => {
					const answerTextContent = window.defaultLocales[`${step}_${currentnswer}`];

					answers.push(answerTextContent);
				});
			} else if (answer) {
				const answerValue = Object.keys(answer)[0];
				answers = window.defaultLocales[`${step}_${answerValue}`];

				if (!answers) {
					answers = answerValue;
				}
			}

			if (answers) {
				steps.analytics.send({
					event: {
						event: 'onboarding_question',
						quiz_question: analyticsNames[step] || window.defaultLocales[step],
						quiz_answer: answers
					}
				});
			}

			if (step === 'diet_type') {
				const intermittentFasting = questions.getAnswers({ questionName: 'intermittent_fasting' }).value || false;

				steps.analytics.send({
					event: {
						event: 'onboarding_question',
						quiz_question: analyticsNames.intermittent_fasting,
						quiz_answer: intermittentFasting
					}
				});
			}
		},
		send ({ event }) {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push(event);
		}
	}
};

export default steps;
